import { render, staticRenderFns } from "./stadium-apply-dialog-detail.vue?vue&type=template&id=01885c91&scoped=true&"
import script from "./stadium-apply-dialog-detail.vue?vue&type=script&lang=js&"
export * from "./stadium-apply-dialog-detail.vue?vue&type=script&lang=js&"
import style0 from "./stadium-apply-dialog-detail.vue?vue&type=style&index=0&id=01885c91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01885c91",
  null
  
)

export default component.exports